export default "__VITE_ASSET__BhEM47DK__"